export default __webpack_public_path__ + "static/media/awbtc.e676d0b7.svg";